import Work1 from "../../../assets/images/navbar/work-01-small.jpg";
import Work2 from "../../../assets/images/navbar/work-02-small.jpg";
import Work3 from "../../../assets/images/navbar/work-03-small.jpg";
import Work4 from "../../../assets/images/navbar/work-04-small.jpg";
import Work5 from "../../../assets/images/navbar/work-05-small.jpg";
import DisplacementEffect from "../../../assets/images/displacement-liquid.png";

export default {
  Work1,
  Work2,
  Work3,
  Work4,
  Work5,
  DisplacementEffect,
};
